function getChartOption(legendData, xAxisData, yAxisData,yAxisMax) {
    const colors = [
        '#dfdfdf', '#e6194B', '#3cb44b', '#4363d8', '#f58231', '#911eb4', '#42d4f4', '#f032e6', '#bfef45', '#fabed4', '#469990', '#dcbeff', '#9A6324', '#fffac8', '#800000', '#aaffc3', '#808000', '#ffd8b1', '#000075', '#a9a9a9', '#ffffff', '#000000'
    ];
    return {
        color: colors,
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross'
            }
        },
        grid: {
            right: '20%'
        },
        toolbox: {
            feature: {
                dataView: { show: true, readOnly: false },
                restore: { show: true },
                saveAsImage: { show: true }
            }
        },
        legend: {
            data: legendData
        },
        xAxis: [
            {
                type: 'category',
                axisTick: {
                    alignWithLabel: true
                },
                data: xAxisData
            }
        ],
        yAxis: [
            {
                type: 'value',
                name: '台次',
                position: 'left',
                alignTicks: true,
                min: 0,
                max: yAxisMax[0],
                axisLabel: {
                    formatter: '{value} 台次'
                }
            },
            {
                type: 'value',
                name: '项目数',
                position: 'right',
                alignTicks: true,
                min: 0,
                max: yAxisMax[1],
                offset: 0,
                axisLabel: {
                    formatter: '{value} 项目数'
                }
            }
        ],
        series: yAxisData
    };
}
export default {
    getChartOption
}